import { AttributeDefinitionType } from 'Types/Tasks.types'
import { AttributeGroup } from './AttributeGroup/AttributeGroup'
import { QCAttributeGroup } from './AttributeGroup/QCAttributeGroup'
import { RatingsAttributeGroup } from './AttributeGroup/RatingsAttributeGroup'
import { IAttributeGroupConstructor } from './AttributeGroup/BaseAttributeGroup'
import { TargetedAttributeGroup } from './AttributeGroup/TargetedAttributeGroup'
import { TurnsAttributeGroup } from 'Core/AttributeCore/AttributeGroup/TurnsAttributeGroup'
import { TurnTargetedAttributeGroup } from 'Core/AttributeCore/AttributeGroup/TurnTargetedAttributeGroup'
import { ClassLevelAttributeGroup } from 'Core/AttributeCore/AttributeGroup/ClassLevelAttributeGroup'

const BuiltInAttributeGroups: BuiltInAttributeGroup[] = [
    { AttributeGroup, attributeDefinitionType: AttributeDefinitionType.EXTRA_INFO },
    {
        AttributeGroup: QCAttributeGroup,
        attributeDefinitionType: AttributeDefinitionType.QUALITY_EVALUATION,
    },
    {
        AttributeGroup: RatingsAttributeGroup,
        attributeDefinitionType: AttributeDefinitionType.RESPONSE_RATING,
    },
    {
        AttributeGroup: TargetedAttributeGroup,
        attributeDefinitionType: AttributeDefinitionType.TARGETED_ATTRIBUTES,
    },
    {
        AttributeGroup: TurnsAttributeGroup,
        attributeDefinitionType: AttributeDefinitionType.TURN_EVALUATION,
    },
    {
        AttributeGroup: TurnTargetedAttributeGroup,
        attributeDefinitionType: AttributeDefinitionType.TURN_TARGETED_ATTRIBUTES,
    },
    {
        AttributeGroup: ClassLevelAttributeGroup,
        attributeDefinitionType: AttributeDefinitionType.CLASS_LEVEL,
    },
]

type BuiltInAttributeGroup = {
    AttributeGroup: IAttributeGroupConstructor
    attributeDefinitionType: AttributeDefinitionType
}

export class AttributeGroupRegistry {
    private static instance: AttributeGroupRegistry

    private attributeGroups: Map<AttributeDefinitionType, IAttributeGroupConstructor> = new Map()

    constructor() {
        this.registerBuiltInGroups()
    }

    static getInstance() {
        if (!AttributeGroupRegistry.instance) {
            AttributeGroupRegistry.instance = new AttributeGroupRegistry()
        }
        return AttributeGroupRegistry.instance
    }

    public register(type: AttributeDefinitionType, group: IAttributeGroupConstructor) {
        this.attributeGroups.set(type, group)
    }

    public get(type: AttributeDefinitionType) {
        return this.attributeGroups.get(type)
    }

    public get all() {
        return Array.from(this.attributeGroups.values())
    }

    private registerBuiltInGroups() {
        BuiltInAttributeGroups.forEach(({ AttributeGroup, attributeDefinitionType }) => {
            this.register(attributeDefinitionType, AttributeGroup)
        })
    }
}
